import './Books.scss'

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import BooksService from '../../services/books.service'
import BookCard from './components/BookCard/BookCard'

const Books = () => {
  const [books, setBooks] = useState([])

  useEffect(() => {
    async function loadBooks() {
      const loadedBooks = await BooksService.listAll()
      setBooks(loadedBooks)
    }

    loadBooks()
  }, [])

  return (
    <div className='content-card'>
      <div className='row page-title'>
        <h1>Livros</h1>
      </div>
      <div className='row content-header'>
        <h3 className='list-title'>Lista de livros</h3>
        <div>
          <Link
            className='button-full statistics-btn'
            to='/books/statistics'
          >
            <i class='fa fa-chart-line'></i> Estatísticas
          </Link>
          <Link
            className='button-full btn-create'
            to='/books/create'
          >
            <i className='fa fa-plus'></i> Criar livro
          </Link>
        </div>
      </div>
      <div className='row books-container'>
        {books.map((book) => (
          <BookCard
            key={book.id}
            book={book}
          />
        ))}
      </div>
    </div>
  )
}

export default Books
